export default __webpack_public_path__ + "static/media/christmasLogoSingle.c3df2926.png";